export default __webpack_public_path__ + "static/media/ilya-yakover.751c23c0.jpg";